import axiosInstance from './axiosInstance';

// Login / Register
export const loginUser = (credentials) =>
  axiosInstance.post('/api/auth/login', credentials);

export const register = (data) =>
  axiosInstance.post('/api/auth/register', data);

export const forgotPassword = (data) =>
  axiosInstance.post('/api/auth/forgot-password', data);

export const resetPassword = (data) =>
  axiosInstance.post('/api/auth/reset-password', data);

// Logout
export const logout = () =>
  axiosInstance.post('/api/auth/logout');

// ✅ Corrected route (backend exposes /users/me)
export const getProfile = () =>
  axiosInstance.get('/api/users/me');

// Misc 
export const email = (data) =>
  axiosInstance.post('/api/auth/email', data);
export const password = (data) =>
  axiosInstance.post('/api/auth/password', data);
